module.exports = __webpack_public_path__ + "img/planetary-rev02.e19c4a66.jpg";